/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {CacheScope, CacheTTL} from '@adobe/exc-app/cache';
import DataPrefetchContract from '@adobe/exc-app/network/DataPrefetchContract';
import {FetchScope} from '@adobe/exc-app/network';
import {Settings, SettingsLevel, SettingsResponse} from '@adobe/exc-app/settings';
import {SETTINGS_QUERY} from '@exc/graphql/src/queries/settings';

export const USER_ROLES_PREFETCH_KEY = 'user-roles';

const gqlDef = {
  dataPath: 'getSettings',
  fetchScope: FetchScope.ORG,
  query: SETTINGS_QUERY,
  variables: {
    appId: 'userPreferences',
    groupId: 'exc-preferences',
    level: SettingsLevel.USER,
    settings: {
      userRoles: null
    }
  }
};

export const userRolesContract: DataPrefetchContract<SettingsResponse<Settings>> = {
  defaultValue: {settings: {userRoles: {roles: []}}},
  expiry: CacheTTL.MONTH,
  gql: gqlDef,
  isSensitive: false,
  key: USER_ROLES_PREFETCH_KEY,
  refreshData: {
    gql: gqlDef
  },
  revalidate: {
    enabled: false
  },
  scope: CacheScope.USER,
  shared: true
};
